export default {
  route: {
    dashboard: '대쉬보드',
    introduction: '소개',
    documentation: '도큐먼트',
    guide: '가이드',
    permission: '허가',
    icons: '아이콘',
    components: '컴포넌트',
    componentIndex: '소개',
    example: '예제',
    Table: '테이블',
    tab: '탭',
    form: '폼',
    errorPages: '페이지 에러',
    page401: '401',
    page404: '404',
    errorLog: '에러 로그',
    excel: '엑셀',
    exportExcel: '엑셀 다운로드',
    uploadExcel: '업로드 엑섹',
    zip: '압축파일',
    exportZip: '압축 다운로드',
    theme: '테마',
    clipboardDemo: '클립보드',
    i18n: 'I18n',
    externalLink: '외부 연결'
  },
  navbar: {
    home: '홈',
    logOut: '로그 아웃',
    dashboard: '대쉬보드',
    screenfull: '풀 스크린',
    theme: '테마',
    size: '사이즈',
    userProfile: '프로필',
    international: '언어',
    logout: '로그아웃',
    settings: '환경 설정'
  },
  login: {
    title: '로긴',
    logIn: '로긴',
    login: '로긴',
    password: '비밀번호',
  },
  permission: {
    roles: '허가',
    switchRoles: '허가 변경'
  },
  table: {
    dynamicTips1: 'Fixed header, sorted by header order',
    dynamicTips2: 'Not fixed header, sorted by click order',
    dragTips1: 'The default order',
    dragTips2: 'The after dragging order',
    title: 'Title',
    type: 'Type',
    search: 'Search',
    add: 'Add',
    export: 'Export',
    id: 'ID',
    date: 'Date',
    author: 'Author',
    readings: 'Readings',
    status: 'Status',
    actions: 'Actions',
    edit: 'Edit',
    publish: 'Publish',
    draft: 'Draft',
    delete: 'Delete',
    cancel: 'Cancel',
    confirm: 'Confirm'
  },
  search: {
    search: '검색',
    label: '레이블'
  },
  action: {
    search: '검색',
    cancel: '취소',
    create: '추가',
    delete: '삭제',
    edit: '수정',
    save: '저장'
  },
  excel: {
    export: '다운로드',
    selectedExport: '선택한 아이템 다운로드',
    placeholder: '파일 이름 입력 (기본값 excel-list)'
  },
  zip: {
    export: '다운로드',
    placeholder: '파일 이름 입력(default file)'
  },
  theme: {
    change: '테마 변경',
    documentation: '테마 도큐먼트'
  },
  tagsView: {
    refresh: '새로 고침',
    close: '닫기',
    closeOthers: '그 외 모두 닫기',
    closeAll: '모두 닫기'
  }
}
